import { render, staticRenderFns } from "./RecipeRouteSelect.vue?vue&type=template&id=4757242c&"
import script from "./RecipeRouteSelect.vue?vue&type=script&lang=js&"
export * from "./RecipeRouteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports